module.exports = __webpack_public_path__ + "static/img/6.18ae1d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/6.png
// module id = I6ga
// module chunks = 0